import { useI18n } from '../i18n/I18nContext';
import type { SyncProgress } from '../sync/downloader';

interface LoadingScreenProps {
  progress?: SyncProgress | null;
}

// Shown after auth while the initial content sync runs, so a fresh device shows
// clear progress instead of a frozen pairing screen or a blank player.
export function LoadingScreen({ progress }: LoadingScreenProps) {
  const { t } = useI18n();

  const total = progress?.total ?? 0;
  const current = total > 0 ? Math.min((progress?.index ?? 0) + 1, total) : 0;
  const pct = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div className="pairing-root" style={{ backgroundColor: 'var(--vz-bg-deep)' }}>
      <div className="pairing-center">
        <div className="pairing-spinner" />
        <div className="loading-title">{t('loading.preparing')}</div>
        {total > 0 && (
          <>
            <div className="loading-sub">
              {t('loading.downloading')} {current} / {total}
            </div>
            <div className="loading-bar">
              <div className="loading-bar-fill" style={{ width: `${pct}%` }} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
